<template>
  <div id="app">
    <!-- 路由匹配到的组件将渲染在这里 -->
    <router-view></router-view>
    <!-- 绑定了入口菜单 -->
    <index id="main" v-show="show" :path="path"></index>
  </div>
</template>
<script>
import TIM from 'tim-js-sdk'
import COS from "cos-js-sdk-v5"
import {mapGetters} from 'vuex'
import index from '@/components/game/index'
export default {
  name: 'App',
  components: {
      index
  },
  data(){
    return{
      tim:null,
      TIM:null,
      path:'',
      show:false,
      screenWidth: document.body.clientWidth,
      showMainList:['/game/home','/game/show','/game/attention','/game/community','/game/my'],
    }
  },
  computed: {
      // 使用对象展开运算符将 getter 混入 computed 对象中
      ...mapGetters([
          'getUserInfo'
      ])
  },
  methods:{
    TIM_ERROR(event) {
        // 收到 SDK 发生错误通知，可以获取错误码和错误信息
        // event.name - TIM.EVENT.ERROR
        // event.data.code - 错误码
        // event.data.message - 错误信息
        console.log('============SDK错误=============')
        console.log(event)
    },
    TIM_CLOSE(event) {
        // 收到 SDK 进入 not ready 状态通知，此时 SDK 无法正常工作
        // event.name - TIM.EVENT.SDK_NOT_READY
        console.log('============SDK以关闭=============')
        console.log(event)
        this.$store.dispatch('logout')
    },
    TIM_KICKED_OUT(event) {
        // 收到被踢下线通知
        // event.name - TIM.EVENT.KICKED_OUT
        // event.data.type - 被踢下线的原因，例如:
        //    - TIM.TYPES.KICKED_OUT_MULT_ACCOUNT 多实例登录被踢
        //    - TIM.TYPES.KICKED_OUT_MULT_DEVICE 多终端登录被踢
        //    - TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED 签名过期被踢 （v2.4.0起支持）。 
        console.log('============被踢下线通知=============')
        console.log(event)

        switch(event.data.type){
            case TIM.TYPES.KICKED_OUT_MULT_ACCOUNT :
                this.$toast.fail('多实例登录被踢')
                break
            case TIM.TYPES.KICKED_OUT_MULT_DEVICE :
                this.$toast.fail('多终端登录被踢')
                break
            case TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED :
                this.$toast.fail('签名过期被踢')
                break
        }
    },
    TIM_NETWORK_INSTABILITY(event) { 
        //  网络状态发生改变（v2.5.0 起支持）。 
        // event.name - TIM.EVENT.NET_STATE_CHANGE 
        // event.data.state 当前网络状态，枚举值及说明如下： 
        //     \- TIM.TYPES.NET_STATE_CONNECTED - 已接入网络 
        //     \- TIM.TYPES.NET_STATE_CONNECTING - 连接中。很可能遇到网络抖动，SDK 在重试。接入侧可根据此状态提示“当前网络不稳定”或“连接中” 
        //    \- TIM.TYPES.NET_STATE_DISCONNECTED - 未接入网络。接入侧可根据此状态提示“当前网络不可用”。SDK 仍会继续重试，若用户网络恢复，SDK 会自动同步消息  
        //console.log('============网络状态发生改变=============')
        switch(event.data.type){
            case TIM.TYPES.NET_STATE_CONNECTING:
                console.error('当前网络不稳定')
                this.$toast.fail('当前网络不稳定')
                break;
            case TIM.TYPES.NET_STATE_DISCONNECTED:
                console.error('当前网络不可用')
                this.$toast.fail('当前网络不可用')
                break;
            default:
                console.log('已接入网络')
                break;
        }
    },
    //成功就加群
    TIM_READY(){
        tim.joinGroup({
            groupID:TIM_Group_Id,
            applyMessage:''
        }).then(function(imResponse) {
            switch (imResponse.data.status) {
              case TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
                // connectStatus = true
                console.log(imResponse.data.group); // 加入的群组资料
                break;
              case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
                // connectStatus = true
                break;
            }
            //console.log('加群成功')
        }).catch(function(imError){
            // connectStatus = false
            console.error(imError)
        });
    },
    TIM_RECEIVE_MESSAGE(){},
    allRoomInit(user,groupId){
        this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.receiveMessage);
        
        this.tim.on(this.TIM.EVENT.ERROR, this.TIM_ERROR);
        
        this.tim.on(this.TIM.EVENT.SDK_NOT_READY, function(event) {
            // 收到 SDK 进入 not ready 状态通知，此时 SDK 无法正常工作
            // event.name - this.TIM.EVENT.SDK_NOT_READY
            console.log('============SDK以关闭=============')
        });
        
        this.tim.on(this.TIM.EVENT.KICKED_OUT, (event) => {
            switch(event.data.type){
                case this.TIM.TYPES.KICKED_OUT_MULT_ACCOUNT :
                    this.$toast.fail('多实例登录被踢')
                    this.$store.dispatch('logout')
                    break
                case this.TIM.TYPES.KICKED_OUT_MULT_DEVICE :
                    this.$toast.fail('多终端登录被踢')
                    this.$store.dispatch('logout')
                    break
                case this.TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED :
                    this.$toast.fail('签名过期被踢')
                    break
            }
        });

        this.tim.on(this.TIM.EVENT.NET_STATE_CHANGE, function(event) { 
            //  网络状态发生改变（v2.5.0 起支持）。 
            // event.name - this.TIM.EVENT.NET_STATE_CHANGE 
            // event.data.state 当前网络状态，枚举值及说明如下： 
            //     \- this.TIM.TYPES.NET_STATE_CONNECTED - 已接入网络 
            //     \- this.TIM.TYPES.NET_STATE_CONNECTING - 连接中。很可能遇到网络抖动，SDK 在重试。接入侧可根据此状态提示“当前网络不稳定”或“连接中” 
            //    \- this.TIM.TYPES.NET_STATE_DISCONNECTED - 未接入网络。接入侧可根据此状态提示“当前网络不可用”。SDK 仍会继续重试，若用户网络恢复，SDK 会自动同步消息  
            console.log('============网络状态发生改变=============')
            switch(event.data.type){
                case this.TIM.TYPES.NET_STATE_CONNECTING:
                    console.error('当前网络不稳定')
                    this.$toast.fail('当前网络不稳定')
                    break;
                case this.TIM.TYPES.NET_STATE_DISCONNECTED:
                    console.error('当前网络不可用')
                    this.$toast.fail('当前网络不可用')
                    break;
                default:
                    console.log('已接入网络')
                    break;
            }
        });
        console.info(this.TIM.EVENT.SDK_READY)
        
        this.tim.on(this.TIM.EVENT.SDK_READY, ()=>{
            console.info('接入成功')
            this.tim.joinGroup({
                groupID:groupId,
                applyMessage:'进入房间'
            }).then((imResponse) => {
                switch (imResponse.data.status) {
                  case this.TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
                    // connectStatus = true
                    console.log(imResponse.data.group); // 加入的群组资料
                    break;
                  case this.TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
                    // connectStatus = true
                    break;
                }
                console.log('加群成功')
            }).catch(function(imError){
                // connectStatus = false
                console.error(imError)
            });
        });
        // 开始登录 
        this.tim.login(user);
    },
    receiveMessage(event) {
      // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
      // event.name - this.TIM.EVENT.MESSAGE_RECEIVED
      // event.data - 存储 Message 对象的数组 - [Message]
      var _self = this
      console.info('==============收到一条消息===========')
      console.log(event)
      var id = event.data[0].ID
      var data = JSON.parse(event.data[0].payload.data)
      switch(data.imMessageType){
          case 11:
              console.info('==================踢出==================')
              console.log(data)
              alert('被踢出')
              break;
          case 19:
              console.info('==================维护下线==================')
              store.dispatch('logout')
              break;
      }
    },
    connectIM(){
      if(this.getUserInfo&&this.getUserInfo.imIdentifier&&this.tim==null){
        let options = {
          SDKAppID: 1400539315//process.env.NODE_ENV !== "development" ? 1400281523 : 1400408061// 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
        };
        // 创建 SDK 实例，`this.TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
        this.tim = this.TIM.create(options); // SDK 实例通常用 tim 表示

        // 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
        // this.tim.setLogLevel(0); // 普通级别，日志量较多，接入时建议使用
        this.tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用

        // 注册 COS SDK 插件
        this.tim.registerPlugin({'cos-js-sdk': COS});
        var user = {userID: this.getUserInfo.imIdentifier, userSig: this.getUserInfo.userSig}
        this.allRoomInit(user,process.env.NODE_ENV !== "development" ? '@TGS#bRLCHXDG5' : "@TGS#bBAK6SUGE",this.receiveMessage)
      }
    },
    joinRoom(groupId,receiveMessage){
        this.TIM_RECEIVE_MESSAGE = receiveMessage
        this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, receiveMessage);
        
        this.tim.on(this.TIM.EVENT.ERROR, this.TIM_ERROR);
        
        this.tim.on(this.TIM.EVENT.SDK_NOT_READY, this.TIM_CLOSE);
        
        this.tim.on(this.TIM.EVENT.KICKED_OUT, this.TIM_KICKED_OUT);

        this.tim.on(this.TIM.EVENT.NET_STATE_CHANGE, (event) => { 
            console.log('============网络状态发生改变=============')
            switch(event.data.type){
                case this.TIM.TYPES.NET_STATE_CONNECTING:
                    console.error('当前网络不稳定')
                    this.$toast.fail('当前网络不稳定')
                    break;
                case this.TIM.TYPES.NET_STATE_DISCONNECTED:
                    console.error('当前网络不可用')
                    this.$toast.fail('当前网络不可用')
                    break;
                default:
                    console.log('已接入网络')
                    break;
            }
        });
        this.tim.joinGroup({
            groupID:groupId,
            applyMessage:'进入房间'
        }).then((imResponse) => {
            switch (imResponse.data.status) {
              case this.TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
                // connectStatus = true
                console.log(imResponse.data.group); // 加入的群组资料
                break;
              case this.TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
                // connectStatus = true
                break;
            }
            console.log('加群成功')
        }).catch(function(imError){
            console.error('加群失败',imError)
            // connectStatus = false
        });
    },
    sendMessage(groupID,textMessage,_self){
        // 1. 创建消息实例，接口返回的实例可以上屏
        let message = this.tim.createCustomMessage({
            to: groupID,
            conversationType: this.TIM.TYPES.CONV_GROUP,
            // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
            // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, this.TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, this.TIM.TYPES.MSG_PRIORITY_LOW, this.TIM.TYPES.MSG_PRIORITY_LOWEST
            // priority: this.TIM.TYPES.MSG_PRIORITY_NORMAL,
            payload: {
                data: JSON.stringify({
                    "imMessageType":4,
                    "content":textMessage
                }),
                description: "",
                extension: ""
            }
        });
        let promise = this.tim.sendMessage(message);
        promise.then(function( { data:{ message:{ID} } } ) {
            var obj = {
                name:_self.getUserInfo.nickName,
                content:textMessage,
                level:_self.getUserInfo.levelMsg.level,
                levelImg:_self.getUserInfo.levelMsg.imgUrl,
                isRoomManager:false,
                nobilityImg:_self.getUserInfo.nobilityMsg?_self.getUserInfo.nobilityMsg.imgUrl:''
            }
            _self.message=''
            _self.keyShow= false
            _self.chatMap.set(ID,obj)
            _self.$forceUpdate()
            _self.scrollBottom()
        }).catch(function(imError) {
            // 发送失败
            console.warn('sendMessage error:', imError);
        });
    },
    exitRoom(groupID){
      this.tim.quitGroup(groupID).then(function(imResponse) {
            console.info('------------退群成功---------------')
            console.log(imResponse)
        }).catch(function(imError){
            console.warn('退群失败:', imError); // 退出群组失败的相关信息
        });
    },
    logout(groupID){
        this.tim.off(this.TIM.EVENT.MESSAGE_RECEIVED, this.TIM_RECEIVE_MESSAGE);
        
        this.tim.off(this.TIM.EVENT.ERROR,this.TIM_ERROR);
        
        this.tim.off(this.TIM.EVENT.SDK_NOT_READY,this.TIM_CLOSE);
        
        this.tim.off(this.TIM.EVENT.KICKED_OUT,this.TIM_KICKED_OUT);

        this.tim.off(this.TIM.EVENT.NET_STATE_CHANGE,this.TIM_NETWORK_INSTABILITY);

        this.tim.off(this.TIM.EVENT.SDK_READY,this.TIM_READY);
        if(groupID){
            //退房间
            this.tim.quitGroup(groupID).then(function(imResponse) {
                console.info('------------退群成功---------------')
                console.log(imResponse)
            }).catch(function(imError){
                console.warn('退群失败:', imError); // 退出群组失败的相关信息
            });
        }
        this.tim.logout().then(function(imResponse) {
            console.info('------------注销成功---------------')
            console.log(imResponse)
        }).catch(function(imError){
            console.warn('注销失败:', imError); // 退出群组失败的相关信息
        });
    }
  },
  mounted(){
    this.TIM = TIM
    const oHtml = document.getElementsByTagName('html')[0]
    const width = oHtml.clientWidth;
    oHtml.style.fontSize = 12 * (width / 320) + "px";
    var _self = this
    window.onresize = () => {
        return (() => {
            window.screenWidth = document.body.clientWidth
            _self.screenWidth = window.screenWidth
        })()
    }
    function onBridgeReady(){
      WeixinJSBridge.call('hideToolbar');
    }

    if (typeof WeixinJSBridge == "undefined"){
        if( document.addEventListener ){
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        }else if (document.attachEvent){
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
    }else{
        onBridgeReady();
    }
    this.connectIM()




    // 禁止橡皮筋效果
  },  
  beforeDestroy(){
    this.logout('@TGS#bRLCHXDG5')
  },
  watch:{
    //是否显示下方入口
    $route:{
      handler(newR,oldR){
        this.show=this.showMainList.includes(newR.path)
        this.path=newR.path
        console.info(newR.path)
      },
      immediate:true,
      deep:true
    },
    screenWidth (width) {
      const oHtml = document.getElementsByTagName('html')[0]
      oHtml.style.fontSize = 12 * (width / 320) + "px";
    }
  }
}
</script>

<style>
  *{
    padding: 0;
    margin: 0;
  }
  
  html{
    font-size: 12px;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    scroll-behavior:smooth;
  }
  #app{
    width: 100vw;
    height: 100vh;
    overflow: hidden scroll;
  }
  #main{
    position: fixed;
    z-index: 1000;
    bottom: 0;
    height: 4em;
    width: 100vw;
    background: #ffffff;
  }
  a{
    color: black;
    text-decoration: none;
  }
  .el-message{
      min-width: 20em !important;
      max-width: 100% !important;
  }
</style>
